// extracted by mini-css-extract-plugin
export default {"cancellationText":"Home_cancellationText__Jpsur","pulse":"Home_pulse__oGoAv"};